export const ourServiceDetails = [
    {
        id:1,
        title: 'Telecom',
        message: 'Our Telecom services offers fast and secure connectivity for all your telecommunication needs. Whether you need to make calls, send messages, or access the internet, our telecom products and service has got you covered.',
        link: 'telecoms',
        image: require('./../images/telecom.png'),
        image_name: 'telecom_img'
    },
    {
        id:2,
        title: 'Payment',
        message: 'We offer quick and secure payment processing to make sure your transactions go off without a hitch, using our user-friendly interface to receive money both locally and internationally. ',
        link: 'payment', //link for payment services
        image: require('./../images/payment.png'),
        image_name: 'payment_img'
    },
    {
        id:3,
        title: 'Card Issuing',
        message: 'Our card issuing service can be tailored to your specific needs as an Individual or business. we issue 3D secured virtual and physical debit USD and NGN cards to spend anywhere Verve, Visa, and Mastercard are accepted, both in-store and online, anytime, anywhere.',
        link: 'CardIssuing', //link for card issuing
        image: require('./../images/card-issuing.png'),
        image_name: 'card-issuing_img'
    },
    {
        id:4,
        title: 'Digital Services',
        message: "We offer a variety of digital services that can be customized to fit your company's needs. Our services are affordable and designed to deliver outstanding results for your company. Our digital experts are devoted to developing your business and catering to your digital needs.",
        link: 'DigitalServices', //link for digital services
        image: require('./../images/digital-services.png'),
        image_name: 'digital-services_img'
    },
    {
        id:5,
        title: 'VTU Development',
        message: "AremxyPlug is a company that has a team of technical experts that can easily and quickly design and develop a VTU platform to start your telecom business with services like airtime top-up, data bundles, education pins, TV subscription, and bills payment platform.",
        link: 'VTU_DEV', //link for vtu-development 
        image: require('./../images/vtu-development.png'),
        image_name: 'vtu-development_img'
    },
    {
        id:6,
        title: 'Business Development',
        message: "Our team of business experts will develop the best strategies to assist you in developing, implementing, and enhancing your digital business capabilities within your company. When it comes to business development, trust us to save you time and stress.",
        link: 'businessDev', //link for business development
        image: require('./../images/biz-development.png'),
        image_name: 'business-development_img'
    },
]